import { defineMessages } from 'react-intl';

export const messages: {
	unitHeader: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	unitHeader: {
		id: 'navigation.ribbon.navigation-ribbon.unit.header',
		description: 'Header for the unit in the navigation ribbon unit switcher.',
		defaultMessage: '{orgName} Units',
	},
});
